import { Config } from 'AppShell/appshell_types/config';

export type CountryCode = 'At' | 'Be' | 'Ch' | 'Cz' | 'De' | 'Es' | 'Fr' | 'It' | 'Nl' | 'Pl' | 'Sk' | 'Pt';

export const getShortenedCountryCode = (countryCode: Config['countryCode']) =>
    (countryCode.charAt(countryCode.length - 2) +
        countryCode.charAt(countryCode.length - 1).toLowerCase()) as CountryCode;
